import React from 'react';

const Phase3Tab = ({ player }) => {
  return (
    <div className="guess-section">
      <h3 className="guess-section-title">Finalen</h3>
      {player.finalPrediction ? (
        <div className="guess-content">
          <p className="guess-item">
            <strong>Gættet finalevinder:</strong> {player.finalPrediction}
          </p>
          <p className="guess-points">
            Point: {player.phase3Points || 0}
          </p>
        </div>
      ) : (
        <p className="no-guess">Ikke gættet endnu</p>
      )}
    </div>
  );
};

export default Phase3Tab;

